import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';

import { TabularTypeDatasetAdapter, tabularTypeDatasetAdapts } from './tabular-type.dataset.adapter';
import { Metamodel } from 'app/model/base/model';
import { PostgreSqlV2Dataset } from 'app/model/dataset/postgre-sql-v2.dataset';
import { GlobalVariables } from 'app/services/globals';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(PostgreSqlV2Dataset),
    asynchronous: true,
    adapts: {
        ...tabularTypeDatasetAdapts,
        properties: {
            ...tabularTypeDatasetAdapts.properties,
            connectionProperties: GlobalVariables.connectionPropertiesForPostgreSql ? '*' : undefined
        }
    }
})
export class PostgreSqlV2DatasetAdapter extends TabularTypeDatasetAdapter<PostgreSqlV2Dataset, Model.DatasetResource> {
}
